import { COUNTRY_CODE_FLAG_ALIASES, UNKNOWN_FLAG_CODE } from './constants';

export const getFlagCode = (countryCode?: string | null): string => {
	const code = countryCode?.toString()?.trim()?.toUpperCase();
	if (!code) return UNKNOWN_FLAG_CODE;
	return (COUNTRY_CODE_FLAG_ALIASES[code] ?? code).toLowerCase();
};
